import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "card mb-4 mb-md-0" }
const _hoisted_4 = { class: "card-header border-0 pt-6" }
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = { class: "svg-icon svg-icon-1 me-2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Search Panel ")
const _hoisted_8 = { class: "card-toolbar" }
const _hoisted_9 = {
  class: "d-flex justify-content-end",
  "data-kt-site-table-toolbar": "base"
}
const _hoisted_10 = { class: "svg-icon svg-icon-2" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Add Production Fusing ")
const _hoisted_12 = { class: "card-header border-0 pt-6 d-none" }
const _hoisted_13 = { class: "card-toolbar w-100" }
const _hoisted_14 = {
  class: "d-flex w-100 justify-content-between align-items-center",
  "data-kt-site-table-toolbar": "selected"
}
const _hoisted_15 = { class: "me-auto" }
const _hoisted_16 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "ms-3"
}, " All ", -1)
const _hoisted_18 = { class: "fw-bolder mx-5" }
const _hoisted_19 = { class: "me-2" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Selected ")
const _hoisted_21 = { class: "card-header border-0 pt-6" }
const _hoisted_22 = { class: "card-title" }
const _hoisted_23 = { class: "row w-100" }
const _hoisted_24 = { class: "col-md-12 d-flex align-items-center position-relative my-1" }
const _hoisted_25 = { class: "card-toolbar" }
const _hoisted_26 = {
  class: "d-flex justify-content-end align-items-center",
  "data-kt-site-table-toolbar": "selected"
}
const _hoisted_27 = {
  key: 0,
  class: "card-body pt-0"
}
const _hoisted_28 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_29 = ["value"]
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "d-flex pt-1 justify-content-end" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil p-0" }, null, -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash p-0" }, null, -1)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = { class: "d-none" }
const _hoisted_39 = {
  key: 0,
  class: "card"
}
const _hoisted_40 = { class: "card-body" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h4", null, "No Data Found", -1)
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" to add new Production Fusing ")
const _hoisted_43 = { class: "card-header ribbon" }
const _hoisted_44 = { class: "card-title" }
const _hoisted_45 = { class: "ribbon-label bg-info" }
const _hoisted_46 = { class: "card-body px-0 pb-0 d-flex align-items-center mb-2" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-vertical h-40px me-3" }, null, -1)
const _hoisted_48 = { class: "flex-grow-1" }
const _hoisted_49 = { class: "d-flex" }
const _hoisted_50 = { class: "" }
const _hoisted_51 = { class: "text-muted fw-bold d-block" }
const _hoisted_52 = { class: "text-muted fw-bold d-block" }
const _hoisted_53 = { class: "card-footer d-flex pt-1" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil" }, null, -1)
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = ["onClick"]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1)
const _hoisted_59 = [
  _hoisted_58
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        class: "back-button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickBack && _ctx.onClickBack(...args)))
      }, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "d-flex align-items-center position-relative my-1 cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSearchPanel = !_ctx.showSearchPanel))
          }, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/abstract/abs027.svg" })
            ]),
            _hoisted_7
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addProductionFusing({})))
            }, [
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotone/navigation/Plus.svg" })
              ]),
              _hoisted_11
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectAllProductionFusing) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.selectAllProductionFusing]
                ]),
                _hoisted_17
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.selectAllProductionFusing
                  ? _ctx.total
                  : _ctx.checkedProductionFusing.length), 1),
              _hoisted_20
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-info me-2",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.exportFewSites()))
            }, " Export CSV Selected ")
          ])
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchData.name) = $event)),
                type: "text",
                class: "form-control",
                placeholder: "Search By Name"
              }, null, 512), [
                [_vModelText, _ctx.searchData.name]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-info",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.searchItems()))
            }, " Search ")
          ])
        ])
      ], 512), [
        [_vShow, _ctx.showSearchPanel]
      ]),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createVNode(_component_Datatable, {
              "table-data": _ctx.tableData,
              "table-header": _ctx.tableHeader,
              "enable-items-per-page-dropdown": false,
              total: _ctx.total,
              rowsPerPage: 10,
              onPageChange: _ctx.onPageChange,
              currentPage: _ctx.currentPage
            }, {
              "cell-checkbox": _withCtx(({ row: site }) => [
                _createElementVNode("div", _hoisted_28, [
                  (_ctx.selectAllProductionFusing)
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 0,
                        class: "form-check-input",
                        type: "checkbox",
                        value: site.id,
                        checked: "",
                        disabled: ""
                      }, null, 8, _hoisted_29))
                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 1,
                        class: "form-check-input",
                        type: "checkbox",
                        value: site.id,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.checkedProductionFusing) = $event))
                      }, null, 8, _hoisted_30)), [
                        [_vModelCheckbox, _ctx.checkedProductionFusing]
                      ])
                ])
              ]),
              "cell-qty": _withCtx(({ row: site }) => [
                _createTextVNode(_toDisplayString(site.qty), 1)
              ]),
              "cell-reQty": _withCtx(({ row: site }) => [
                _createTextVNode(_toDisplayString(site.reQty), 1)
              ]),
              "cell-status": _withCtx(({ row: site }) => [
                _createElementVNode("p", null, _toDisplayString(site.status), 1)
              ]),
              "cell-waste": _withCtx(({ row: site }) => [
                _createTextVNode(_toDisplayString(site.waste), 1)
              ]),
              "cell-remark": _withCtx(({ row: site }) => [
                _createElementVNode("p", null, _toDisplayString(site.remark), 1)
              ]),
              "cell-production_data": _withCtx(({ row: site }) => [
                _createTextVNode(_toDisplayString(site.production_data.qty), 1)
              ]),
              "cell-design_material_item_id_data": _withCtx(({ row: site }) => [
                _createTextVNode(_toDisplayString(site.design_material_item_id_data.code), 1)
              ]),
              "cell-created_by": _withCtx(({ row: site }) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.userList[site.created_by]?.name), 1)
              ]),
              "cell-actions": _withCtx(({ row: site }) => [
                _createElementVNode("div", _hoisted_31, [
                  (_ctx.hasEdit)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn btn-primary btn-sm mx-2",
                        onClick: ($event: any) => (_ctx.addProductionFusing(site))
                      }, _hoisted_34, 8, _hoisted_32))
                    : _createCommentVNode("", true),
                  (_ctx.hasDelete)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "btn btn-danger btn-sm mx-2",
                        onClick: ($event: any) => (_ctx.deleteProductionFusingItem(site))
                      }, _hoisted_37, 8, _hoisted_35))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["table-data", "table-header", "total", "onPageChange", "currentPage"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", null, [
        (_ctx.tableData.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("p", null, [
                  _createElementVNode("span", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addProductionFusing({}))),
                    class: "cursor-pointer text-primary"
                  }, "Click here"),
                  _hoisted_42
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "card card-flush mb-4 shadow",
            key: item.id
          }, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("h3", _hoisted_44, _toDisplayString(item.status), 1),
              _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.userList[item.created_by]?.username), 1)
            ]),
            _createElementVNode("div", _hoisted_46, [
              _hoisted_47,
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, " Re-qty: " + _toDisplayString(item.reqty), 1),
                    _createElementVNode("div", _hoisted_52, " Quantity : ₹ " + _toDisplayString(item.qty), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary mx-2 w-100",
                onClick: ($event: any) => (_ctx.addProductionFusing(item.id))
              }, _hoisted_56, 8, _hoisted_54),
              false
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-danger mx-2 w-100",
                    onClick: ($event: any) => (_ctx.deleteProductionFusingItem(item))
                  }, _hoisted_59, 8, _hoisted_57))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}